/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Table,
  CardText,
} from "reactstrap";
import { Bar } from "react-chartjs-2";
import Chart from "chart.js/auto";
import { CategoryScale, LinearScale } from "chart.js";

const Item = ({ item, currentIndex, setCurrentIndex }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);
  const selectedYearData = item[currentIndex]?.data?.sort(
    (a, b) => a.month - b.month
  );

  const monthArray = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const onClickHandler = (year) => {
    let index = item.findIndex((ele) => ele.year === year);

    if (index >= 0) {
      setCurrentIndex(index);
      setDropdownOpen(false);
    }
  };

  return (
    <Card className="my-3 border-0 shadow">
      <CardHeader className="text-white bg-header">
        <i className="icon-calender fs-16"></i>{" "}
        <Dropdown
          isOpen={dropdownOpen}
          toggle={toggle}
          style={{ cursor: "pointer" }}
        >
          <DropdownToggle caret size="lg" data-toggle="dropdown" tag="span">
            {item[currentIndex].year}
          </DropdownToggle>
          <DropdownMenu>
            {item.map((ele) => (
              <DropdownItem
                key={ele.year}
                onClick={() => onClickHandler(ele.year)}
              >
                {ele.year}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </CardHeader>
      <CardBody className="p-0">
        <Table responsive>
          <thead className="border">
            <tr>
              <th style={{ fontSize: "14px", letterSpacing: "0.2px" }}>
                Month
              </th>
              <th style={{ fontSize: "14px", letterSpacing: "0.2px" }}>
                Height
              </th>
              <th style={{ fontSize: "14px", letterSpacing: "0.2px" }}>
                Weight
              </th>
            </tr>
          </thead>
          <tbody className="border">
            {selectedYearData?.map((ele, index) => (
              <tr key={index}>
                <td style={{ fontSize: "15px", letterSpacing: "0.2px" }}>
                  <CardText>{monthArray[ele.month]}</CardText>
                </td>
                <td style={{ fontSize: "15px", letterSpacing: "0.2px" }}>
                  {" "}
                  <CardText>{ele.height} cm</CardText>
                </td>
                <td style={{ fontSize: "15px", letterSpacing: "0.2px" }}>
                  {" "}
                  <CardText>{ele.weight} kg</CardText>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default Item;
